import { useMutation } from '@tanstack/react-query';
import { checkAnswer } from '../queries/post';
import { CheckAnswerBody } from '../model/dto';

export function useCheckPracticeRevisionQuestion() {
  const { mutate, data, isPending, isSuccess } = useMutation({
    mutationKey: ['checkPracticeRevisionQUestion'], 
    mutationFn: (props: {id: string, body: CheckAnswerBody}) => checkAnswer(props.body, props.id),
    retry: false
  });

  return { mutate, data, isPending, isSuccess };
}
